export default {
  index: [
    {
      path: '/zkptfhjc',
      component: resolve => require(['./zkptfhjcIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkptfhjc/_router.js